import React from 'react';
import { Navigate } from 'react-router-dom';

function Protected({ Component, childrenProps={} }) {

    const verificationToken = localStorage.getItem('verificationToken'); 
    if(!verificationToken){ 
      return <Navigate to="/" />;
    }

    return (
      <>
        <main>
          <Component {...childrenProps} />
        </main>
      </>
    );
  }
  
  export default Protected;